import './team.scss';

import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/scss';

class Team {
    constructor ($element) {
        this.$team = $element;
        this.maxTabletBp = window.matchMedia('(max-width: 1024px)');
        this.$slider = this.$team.querySelector('[data-team="slider"]');
        this.slider = null;
        this.sliderActive = false;

        this.$$cards = this.$team.querySelectorAll('[data-team="card"]');
        this.$cardCta = this.$team.querySelector('[data-team="card-cta"]');
    }

    init () {
        this.checkSize(this.maxTabletBp.matches);

        this.maxTabletBp.addEventListener('change', (e) => {
            this.checkSize(e.matches);
        });

        this.$$cards.forEach(card => {
            console.log('card', card);
            const cardCtas = card.querySelectorAll('[data-team="card-cta"]');
            cardCtas.forEach(cta => {
                console.log('cta', cta);
                cta.addEventListener('click', () => {
                    console.log('click');
                    card.classList.toggle('team__card--open');
                });
            });
        });
    }

    checkSize (maxTabletBp) {
        if (maxTabletBp) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            console.log('is BIGGER than tab');
            if (this.sliderActive === true) {
                this.destroySlider();
            }
        }
    }

    initSlider () {
        this.sliderActive = true;
        this.slider = new Swiper(this.$slider, {
            modules: [Navigation, Pagination],
            slidesPerView: 'auto',
            speed: 500,
            autoHeight: false,
            navigation: {
                el: this.$team.querySelector('.team__slider-navigation'),
                nextEl: this.$team.querySelector('.slider-button-next'),
                prevEl: this.$team.querySelector('.slider-button-prev')
            },
            pagination: {
                el: this.$team.querySelector('.slider-pagination'),
                type: 'fraction',
                formatFractionCurrent: function (number) {
                    return ('0' + number).slice(-2);
                },
                formatFractionTotal: function (number) {
                    return ('0' + number).slice(-2);
                }
            },
            on: {
                init: function (swiper) {
                    console.log('swiper initialized', swiper);
                },
                afterInit: () => {
                    if (this.$team.querySelector('.slider-button-next').classList.contains('swiper-button-disabled') & this.$team.querySelector('.slider-button-prev').classList.contains('swiper-button-disabled')) {
                        this.$team.querySelector('.team__slider-navigation').style.display = 'none';
                    } else {
                        this.$team.querySelector('.team__slider-navigation').style.display = 'flex';
                    }
                }
            }
        });
    }

    destroySlider () {
        if (typeof this.slider !== 'undefined' && this.slider !== null) {
            this.slider.destroy();
            this.sliderActive = false;
            this.$team.querySelector('.team__slider-navigation').style.display = 'none';
        }
        console.log('destroy');
    }
}

export { Team };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $teams = $context.querySelectorAll('[data-team="root"]');

        for (let i = 0; i < $teams.length; i++) {
            const $team = new Team($teams[i]);
            $team.init();
        }
    }
});
